import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import * as HolidayJp from '@holiday-jp/holiday_jp';

const setCalendar = () => {
  const calendarElement = document.getElementById('js-narrow-calendar');
  if (!calendarElement) return;

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  // const initialMonth = `${year}-${month}-01`;
  // const startMonth = `${year - 1}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
  // const endMonth = `${year + 1}-${String(today.getMonth() + 2).padStart(2, "0")}-01`;
  const initialMonth = '2026-09-01';
  const startMonth = '2026-09-01';
  const endMonth = '2027-01-01';

  const selectedDateInput = calendarElement.querySelector('.js-selected-date'),
    dateCheck = calendarElement.querySelector('.js-date-check');

  const params = new URLSearchParams(window.location.search);

  let selectedDate = params.get('date') ? params.get('date') : null;

  const calendar = new Calendar(calendarElement, {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    validRange: {
      start: startMonth,
      end: endMonth
    },
    initialDate: selectedDate || initialMonth,
    dayHeaderFormat: { weekday: 'narrow' },
    headerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    height: "auto",
    dayCellContent: ({ date }) => date.getDate(),
    datesSet: (info) => updateCalendarView(calendarElement, selectedDate, info),
    dateClick: (info) => setSelectedDate(info, calendarElement, selectedDateInput, dateCheck),
    dayCellDidMount(info) {
      const holidays = HolidayJp.between(info.date, info.date);
      if (holidays.length > 0) {
        info.el.classList.add('fc-day-holiday');
      }
    }
  });

  calendar.render();

  dateCheck?.addEventListener('change', (e) => {
    if (e.target.checked) {
      clearSelectedDate(calendarElement, selectedDateInput);
    }
  });
};

// カレンダーのビューを更新する関数
const updateCalendarView = (calendarElement, selectedDate, info) => {
  calendarElement.querySelectorAll('.fc-scrollgrid-sync-table tr').forEach(row => {
    row.classList.remove('is-hide');
    if (row.querySelectorAll('.fc-day-other, .fc-day-disabled').length === 7) {
      row.classList.add('is-hide');
    }
  });

  if (selectedDate) {
    calendarElement.querySelector(`[data-date="${selectedDate}"]`)?.classList.add('is-selected');
  }

  const year = info.view.currentStart.getFullYear();
  const month = info.view.currentStart.getMonth() + 1;

  const titleEl = calendarElement.querySelector('.fc-toolbar-title');

  if (titleEl) {
    titleEl.textContent = `${year}/${month}`;
  }
};

// 日付を選択した際の処理
const setSelectedDate = (info, calendarElement) => {
  location.href = `${calendarElement.dataset.baseUrl}?date=${info.dateStr}`
};

// 選択した日付をクリアする処理
const clearSelectedDate = (calendarElement, selectedDateInput) => {
  selectedDateInput.value = null;
  calendarElement.querySelectorAll('.fc-day.is-selected').forEach(date => date.classList.remove('is-selected'));
};

export default setCalendar;